import React from 'react';
import PropTypes from 'prop-types';

function EmptyRow({
    height
}) {
    return (
        <div style={{ display: 'inline-block', height: height }} />
    );
}

EmptyRow.propTypes = {
    height: PropTypes.number
}

export default React.memo(EmptyRow);